import { TPicture } from 'types/picture';
import { TTask } from 'types/task';

import { apiRequest } from '@utils/apiRequest';

import { TClientTask } from '../types';

type TPictureEmpty = string;

export async function actionImages<T extends 'saveFileBatch' | 'removeFileBatch'>(
    entityId: number,
    imageFiles: number[] | File[] | null,
    type: T
) {
    const key = typeof imageFiles?.[0] === 'number' ? 'ids' : 'pictures';
    const responseImageData = await apiRequest(async (api, crm_id) => {
        return api[type]({
            crm_id,
            model: 'tasks',
            id: entityId,
            defaultID: null,
            ...(imageFiles ? { [key]: imageFiles } : []),
        });
    });
    return (responseImageData.data.data ||
        responseImageData.data) as unknown as T extends 'saveFileBatch'
        ? TPicture[]
        : TPictureEmpty[];
}

export async function actionImage<T extends 'saveFile' | 'removeFile'>(
    entityId: number,
    imageFile: File | null,
    type: T
) {
    const responseImageData = await apiRequest(async (api, crm_id) => {
        return api[type]({
            crm_id,
            model: 'task',
            entity_id: entityId,
            ...(imageFile ? { picture: imageFile } : {}),
        });
    });

    return (responseImageData.data.data ||
        responseImageData.data) as unknown as T extends 'saveFile' ? TPicture : TPictureEmpty;
}

export async function actionTask(clientTaskData: TClientTask, type: 'saveTask' | 'updateTask') {
    const responseTaskData = await apiRequest(async (api) => {
        return api[type](clientTaskData as TTask);
    });

    // const serverTaskData = responseTaskData?.data?.data
    // const imagesToSave = clientTaskData?.pictures.filter(image => image?.constructor.name === 'File')

    // const imagesId = new Set(clientTaskData?.pictures.map(image => image.id));
    // const imagesIdToDelete = serverTaskData?.pictures.filter(image => !imagesId.has(image.id)).map(image=>image.id)

    // if (imagesToSave.length) {
    //     await uploadImageBatch(serverTaskData.id, imagesToSave as File[])

    //     serverTaskData.pictures = clientTaskData.pictures as TPicture[]
    // }

    // if (imagesIdToDelete?.length) {
    //     await removeImageBatch(serverTaskData.id,imagesIdToDelete)

    //     serverTaskData.pictures = clientTaskData.pictures as TPicture[]
    // }

    return responseTaskData?.data?.data;
}

export const uploadImageBatch = async (entityId: number, imageFiles: File[]) => {
    return await actionImages(entityId, imageFiles, 'saveFileBatch');
};

export const removeImageBatch = async (entityId: number, imageFiles: number[]) => {
    return await actionImages(entityId, imageFiles, 'removeFileBatch');
};

export const uploadImage = async (entityId: number, imageFile: File) => {
    return await actionImage(entityId, imageFile, 'saveFile');
};

export const removeImage = async (entityId: number) => {
    return await actionImage(entityId, null, 'removeFile');
};

export const createTask = async (taskData: TClientTask) => {
    return await actionTask(taskData, 'saveTask');
};

export const updateTask = async (taskData: TClientTask) => {
    return await actionTask(taskData, 'updateTask');
};
